import { inject, Injectable } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { BehaviorSubject, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnleashFacade {
  private unleashService = inject(UnleashService);

  isUnleashClientReady$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor() {
    this.unleashService.ready$
      .pipe(
        take(1),
        tap(() => this.isUnleashClientReady$.next(true)),
      )
      .subscribe();

    this.unleashService.error$
      .pipe(tap(() => this.isUnleashClientReady$.next(true)))
      .subscribe();
  }
}
